import { render, staticRenderFns } from "./ModalLogin.vue?vue&type=template&id=84ba9790&"
import script from "./ModalLogin.vue?vue&type=script&lang=js&"
export * from "./ModalLogin.vue?vue&type=script&lang=js&"
import style0 from "./ModalLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports